const tr = {
  requirementList: "需求清單",
  material: "物控",
  purchase: "採購",
  prod: "生產",
  finance: "財務",
  sale: "業務",
  materialStatus: "物控稽核狀態",
  purchaseStatus: "採購稽核狀態",
  prodStatus: "生產稽核狀態",
  financeStatus: "財務稽核狀態",
  saleStatus: "業務稽核狀態",
  materialDesc: "物控審核備註",
  purchaseDesc: "採購審核備註",
  prodDesc: "生產審核備註",
  financeDesc: "財務審核備註",
  saleDesc: "業務審核備註",

  commodity: '產品',
  commodityStatus: '產品審核狀態',
  commodityDesc: '產品審核備註',

  passed: "已通過",
  notPass: "未通過",
  approvalTip: "請輸入稽核備註",
  listSearchTip: "輸入編號、描述、產品資訊進行蒐索",

  number: "編號",
  bomAmount: "用量",
  requireCount: "所需數量",
  itemCountInfo: "所需單品數",
  materialProgress: "物料準備進度",
  mrd: "要求齊料時間",
  plMrd: "請先填寫要求齊料時間",
  mcPre: "物控備品量",
  bomData: "標準數量總數",
  estimatedCost: "預估花費",
  passStatus: "審批狀態",

  errorTip: "錯誤提示",
  errorDesc: "錶中存在數據异常,你確定不進行修改後提交嗎？",
  noRepl: "暫無替代料可選",
  selectRepl: "選擇替代料",
  allCount: "總數量已進行向上取整,您可以根據實際情況修改總使用量",

  matchBom: "匹配Bom錶",
  editQuantity: "修改數量",
  matchInventory: "匹配庫存",
  alrPreOutNum: "已預出庫數量",
  preOut: "預出庫",
  confirmPickOut: "本次預出庫數量小於實際可出庫數量時，以實際可出庫數量為準生成領料單，是否生成預出庫單？",
  confirmPro: "確定物資數據",
  prePickOut: "生成預出庫單",
  prePickOutNum: "本次預出庫數量",
  actualOutNum: "實際可出庫數量",
  addDesc: "添加備註",
  done: "完成",
  doneSuccess: "成功生成需求清單",
  doneSuccessTip: "需求清單{{ number }}已初步生成,將由相關業務繼續進行下一步操作",
  next: "下一步",
  previous: "上一步",
  requirementAdd: "生成需求清單",
  selectPro: "選擇商品",
  searchPro: "輸入產品關鍵字查詢",

  detail: "需求清單詳情",
  orderDetail: "訂單詳情",

  purCount: "需採購數量",
  purEdCount: "採購到貨數量",
  preInCount: "預入庫數量",
  preOutCount: "預出庫數",
  minPrice: "最低單價",
  maxPrice: "最高單價",
  minCost: "最低成本",
  maxCost: "最高成本",
  supplierAndPrice: "供應商與價格選擇",
  addPurDesc: "新增採購描述",

  notApproved: "暫未審批",

  requirementAppInfo: "需求清單評審資訊",
  eps: "預計上線日期",
  plEps: "請填寫預計上線時間",
  saveTemp: "儲存範本",
  saveTempSuccess: "模板新增成功",
  useQuantity: "單品使用數量",
  addConfirm: "你確定要添加這個需求單嗎？",
  selectProdPro: "選擇生產母件",
  plSelectProdPro: "請選擇要生產的母件",
  product: "母件",
  prodCount: "生產數量",
  plProdCount: "請輸入生產數量",
  desc: "需求清單備註",
  plDesc: "請輸入需求清單備註",
  plSubPro: "選擇子件資訊",
  tempSuccess: "範本創建成功",
  validError: "校驗錯誤",
  addRequirement: "添加需求清單",
  total: '總數',
  success: '成功',
  failed: '失敗',
  exportExcel: "匯出 Excel",
  requirementCreate: "生成需求清單",
  mainInfo: "主件資訊",
  flow: "審批流",
  delSubTip: "你確定要刪除選中子件嗎？ 刪除後無法進行恢復",
  syncClearRequirementItems: "同步清除需求單項",
  syncClearRequirementItemsTip: "你確定要刪除當前需求清單下所有需求清單項嗎？刪除後無法進行恢復",
  delOrderItemTip: "是否刪除對應的領料單？",
  delPurchaseOrderItemTip: "是否刪除對應的採購單？",
  selectAll: "全選",
  oked: "已通過",
  pending: "待進行",
  rejected: "已拒絕",
  rejectTip: "你確定要拒絕這個需求清單嗎？ 拒絕後,會返回業務上一步操作",
  rejectReason: '拒絕原因',
  rejectReasonRequired: '請輸入拒絕原因',
  rejectReasonPlaceholder: '請詳細說明拒絕的原因...',
  rejectReasonMaxLength: '拒絕原因不能超過500個字符',
  closeTip: "你確定要歸檔這個需求清單嗎？ 歸檔後,數據將無法更改",
  supplier: "供應商",
  ert: "預計交貨時間",
  supplierPriceNo: "暫無供應商價格可選",
  surOk: "添加採購單成功,請篩選頁面查看",
  surSure: "請確認有可採購數據",
  reject: "拒絕",
  close: "關閉",
  saleNum: '銷售數量',
  prNum: '生產數量',
  plPrNum: '請輸入生產數量',
  orderAlready: '該訂單已生成需求單',
  orderDate: "訂單日期",
  pricePreview: '產品價格預覽',
  endError: "你確定這個訂單已經完成嗎?",
  plSeSupplier: "選擇供應商",
  plPlacePrice: "選擇下單價格",
  noPurchaseTip: "暫無資料可用於採購",
  okPurchase: "確認購買",
  onKeyQutote: '一鍵問詢',
  subQutote: '分批問詢',
  onKeyPrice: '一鍵詢價',
  subPrice: '分批詢價',
  onKeyPurchese: '一鍵生成預採購單',
  sendQutote: '問詢單已發送',
  sendQutotePro: '已發送{{len}}個項目的詢價請求',
  ddl: '截止時間',
  noSupplier: '暫無可發送問詢單的供應商',
  qutoteSednFail: '發送問詢單失敗',
  autoPurcheseSucc: '自動生成預採購單成功，部分物料沒有有效報價無法生成預採購單',
  supplierProgress: '供應商迴響進度',
  unRead: '未讀',
  read: '已讀',
  unPriced: '待報價',
  resolved: '已報價',
  qutotationProgress: '詢價單進度詳情',
  matInfo: '物料資訊',
  requirementInfo: '報價資訊',
  requirementHelp: '協助報價',
  supplierQuote: '供應商報價',
  status: '狀態',
  days: '供貨週期',
  mpq: '最小包裝',
  supplierTime: '齊料時間',
  edit: '編輯',
  resped: '已迴響',
  unResp: '未迴響',
  rulePrice: '契約價',
  ruleDays: '契約供貨週期',
  ruleMpq: '契約最小包裝',
  price: '價格',
  inputPrice: '請輸入價格',
  priceTip: '提示：報價比契約價要高,可能會導致報價無效哦',
  inputDays: '請輸入供貨週期',
  daysTip: '提示：供貨週期大於契約供貨週期,可能會導致報價無效哦',
  mpqTip: '提示：最小包裝數大於契約最小包裝數,可能會導致報價無效哦',
  inputSuppTime: '請輸入齊料時間',
  addSuppQutoteTip: '此供應商已有詢價單,無需新增',
  addSuppQutote: '新增供應商報價',

  inputMpq: '請輸入最小包裝',
  ddlTime: '最晚交貨時間',
  inputDdlTime: '請輸入最晚交貨時間',
  ddlTimeTip: '提示：最晚交貨時間超過了要求齊料時間，超時可能會導致報價無效哦',
  prevDMrd: '預計交貨時間',
  deadline: '最晚提交時間',

  nuRead: '未讀',
  timedOut: '已逾期',
  day: '天',
  hour: '小時',
  purTip: "確定產生預採購單？",
  purContent: "這將自動產生預採購單",

  salePrice: "銷售金額",
  mateCost: "物料成本",
  notCount: "未計算",
  netProfit: "淨利",
  goPur: "生成採購單",

  lazyQuota: '延時報價',
  lazyQuotaSuc: '延時報價成功',
  lazyQuotaErr: '延時報價失敗',
  lazyTime: '選擇或輸入要延時的時間段',
  curLazy: '當前報價截止時間',

  notSelect: '部分物料沒有有效報價，請確保每個物料都存在有效報價後再進行通過',
  notSelectTip: '以下物料不存在有效報價',
  purchaseProgress: '採購單進度',
  quotationProgress: '問詢單發送進度',
  noQuotationTip: '標紅物料不存在有效報價',
  searchPlaceHolder: '輸入供應商或產品資訊查詢',
  allQuotation: '全部問詢單',
  purchaseOrders: '採購訂單',
  prePurchaseOrders: '預採購單',
  preview: '預覽',
  toGen: '待生成',


  unApprove: '待稽核',
  approved: '已稽核',
  timed: '已過期',
  updatePrice: '修改報價',
  rePrice: '重新報價',
  quotation: '報價審批',
  reSelect: '手動選擇',
  selected: '已選擇',
  reSelecteDone: '已重新選擇',
  reSelecteFail: '重新選擇失敗',
  createPreOutInventory: '生成預出庫單',
  createPreOutInventoryCon: "確定生成領料出庫單？",
  createPreOutInventorySuccess: '生成預出庫單成功',
  createPreOutInventoryFail: '生成預出庫單失敗',
  noPreOutInventory: '沒有可出庫物料',
  pleaseSelect: '請選擇物料',
  preOutInventory: '預出庫單',
  goodsName: '物料名稱',
  availableQuantity: '可出庫數量',
  outboundType: '出庫單類型',
  inCount: '入庫數量',
  outCount: '出庫數量',
  shouldOutCount: '應發數量',
  actualOutCount: '實發數量',
  requirmentQuantity: '需求單數量',
  preReadyGood: '常備物料無需出庫',
  outInventory: '出庫單',
  notQuo: "無需報價",
  notPur: "無需採購",
  curMrd: "當前交貨時間",
  selMrd: "選擇最終交貨時間",
  finalMrd: "最終交貨時間",
  mrdEdit: "預計交貨時間調整",
  quoEdit: "問詢單修改",
  closeReq: "關閉需求單",
  editNum: "修改需求清單數量",

  plReqCount: "請輸入所需數量",
  plPurCount: "請輸入需採購數量",
  purCountErr: "需採購數量必須小於所需數量",
  bomAmountErr: "請輸入有效的BOM用量",
  quantityAndBomAmount: "數量和用量不能為空或為 0",
  skipStock: "跳過匹配庫存（不進行預出庫）",
  skipMerge: "合併相同物料（相同的物料合併，數量相加）",
  finalPurQuantity: "最終採購數量",
  quotationTip: "報價後不可再進行修改，是否確定提交報價？",
  notAddCloseTip: "物料還未添加，是否確認關閉？",
  confirmAddProduct: "確認添加商品信息",
  duplicateMaterialTip: "標黃物料代表該物料存在另一個相同物料",
  matching: "正在匹配...",
  documentGenerationFailed: "文檔生成失敗",
  printFailed: "打印失敗",
  pdfGenerationFailed: "生成PDF失敗",
  requirementListAll: "需求清單_全部",
  exportMatchResult: "導出匹配結果",

  // MultiPurchaseSteps 批量採購下單
  multiPurchaseTitle: "批量採購下單",
  selectSupplier: "選擇供應商",
  matchProduct: "匹配料號",
  matchPrice: "匹配價格",
  generatePurchase: "生成採購單",
  acceptPurchase: "接受採購單",
  complete: "完成",
  nextStep: "下一步",
  prevStep: "上一步",
  tip: "提示",
  enterGenerateTip: "進入生成採購步驟之後不可回退",
  confirmClose: "確定關閉？",
  closeTipContent: "採購單還未生成，確定關閉？",

  // MatchProduct 匹配料號
  oneClickAddProduct: "一鍵添加物料",
  addingProduct: "正在添加物料",
  processed: "已處理：",
  productsWithoutPrice: "標紅物料是該供應商所在系統中不存在的物料，需要為該供應商系統添加此物料",
  noNeedAddProduct: "無需添加物料",
  noNeedAddProductDesc: "沒有不存在的物料，無需添加",
  supplierApiError: "供應商Api異常，請檢查",
  productMatchFailed: "物料匹配失敗",
  productMatchFailedDesc: "供應商Api:",
  successAddProduct: "成功添加",
  productAddFailed: "個物料，失敗",
  oneClickAddPrice: "一鍵添加價格",
  addingPrice: "正在添加價格",
  productsWithoutPriceTip: "標紅物料是該供應商系統中不存在價格的物料，需要為該供應商系統添加此物料價格",
  noNeedAddPrice: "無需添加價格",
  allProductsHavePrice: "所有物料已有價格",
  supplierIdError: "供應商ID異常，請檢查",
  successAddPrice: "成功添加",
  priceAddFailed: "個價格，失敗",

  // GeneratePurchase 生成採購單
  oneClickOrder: "一鍵下單",
  ordering: "正在下單",
  successGeneratePurchase: "成功生成",
  purchaseOrder: "個採購單",
  generatePurchaseFailed: "個採購單，失敗",
  purchaseOrderNumber: "採購單號",
  purchaseQuantity: "採購數量",
  orderStatus: "訂單狀態",
  ordered: "已下單",
  finished: "已完成",
  notOrdered: "未下單",
  acceptStatus: "接受狀態",
  accepted: "已接受",
  oneClickAccept: "一鍵接受",
  accepting: "正在接受採購單",
  noData: "無數據",
  noPurchaseOrderToAccept: "沒有需要接受的採購單",
  successAccept: "成功接受",
  acceptFailed: "個採購單，失敗",
  noPurchaseDataTip: "無需採購和已生成預採購單的數據不進行採購下單",
  swapSale: "轉單",
  // SwapSaleOrder 轉單
  noDataToTransfer: "沒有可以轉單的數據",
  noDataToTransferDesc: "無需採購和已經生成預採購單的數據不進行轉單",
  supplierApiLabel: "供應商Api：",
  fetchOrgInfoFailed: "獲取組織信息失敗",
  orgLabel: "組織：",
  selectSupplierAndCustomer: "請選擇供應商組織和終端客戶",
  noMatchedProductData: "沒有匹配的產品數據",
  saleOrderTransferSuccess: "銷售單轉單成功",
  saleOrderNumber: "銷售單號：",
  saleOrderGenerateFailed: "銷售單生成失敗",
  selectSupplierFirst: "請選擇供應商",
  selectSupplierOrg: "請選擇供應商組織",
  selectSupplierCustomer: "請選擇供應商終端客戶",
  confirmGenerateSaleOrder: "確定生成銷售單麼？",
  generateSaleOrderForSupplier: "給供應商：",
  swapEnd: "信息匹配失敗，轉單終止。",
  noCustomerPrice: "標紅的物料在供應商系統中不存在此終端客戶價格",
  plAddCustomerPrice: "請去供應商系統中添加該終端客戶的物料價格",
  noProducts: "標紅的物料在供應商系統中不存在",
  plAddProdictOne: "1、去供應商系統中添加這些物料信息",
  plAddProdictTwo: "2、去供應商系統中添加這些物料的商品價格",
  closeSaleOrderTip: "是否刪除關聯的銷售單：",
  plAddSupplierPrice: "標紅物料不存在該供應商價格，請先維護本系統這些物料的供應商價格",
  batchSelect: "批量選中問詢單",
  progress: "進度",
  importQuotationExcel: "導入報價Excel",
  quotationImportPreview: "供應商報價導入預覽",
  quotationImportRowNumber: "行號",
  quotationImportRequirementItemId: "需求項ID",
  quotationImportSupplierCode: "供應商編碼",
  quotationImportSupplierName: "供應商名稱",
  quotationImportPrice: "價格",
  quotationImportMpq: "最小包",
  quotationImportStatus: "狀態",
  quotationImportItemIdRequired: "需求項ID不能為空",
  quotationImportItemNotFound: "需求項ID不存在或已失效",
  quotationImportProductMismatch: "需求項ID與存貨編碼不匹配",
  quotationImportSupplierRequired: "供應商編碼不能為空",
  quotationImportSupplierLoadFailed: "供應商數據加載失敗",
  quotationImportPriceInvalid: "價格必須是大於0的有效數字",
  quotationImportMpqInvalid: "最小包必須是大於0的有效數字",
  quotationImportNoMrd: "需求單未設置MRD，無法確定最晚交貨期",
  quotationImportInvalidHeader: "導入文件表頭不正確，請使用當前詳情導出的文件",
  quotationImportFileEmpty: "導入文件沒有可處理的數據",
  quotationImportParseFailed: "導入文件解析失敗",
  quotationImportSubmitFailed: "供應商報價新增失敗",
  quotationImportReady: "可提交",
  quotationImportReselect: "重新選擇文件",
  quotationImportHasErrors: "存在校驗錯誤，請修正Excel後重新導入",
  quotationImportSummary: "成功 {{success}} 條，失敗 {{failed}} 條",
  salePass: "轉為正式訂單",
  downloadTemplate: "下載模版",
  inputTemp: "從模版錄入",
  importTemplate: "需求清單導入模版",
  invalidTemplate: "請選擇正確的模版文件",
  parseDataSuccess: "成功解析 {{count}} 條數據",
  atLeastOnePreOutGreaterThanZero: "至少一個預出庫數量大於0",
  cusOrderQty: "客戶訂單數量",
  cusOrderQtyTip: "轉單訂單",
  processFilter: "搜索物料製程",
  delErrTip: "以下物料存在已出庫數量，不可刪除！",
  mixReplaced: "組合使用替代料",
  preOutDesc: "預出庫備註",
  prePickOutLimitAutoTip: "本次預出庫數量已自動限制在合法範圍內",
  prePickOutRemainLimit: "剩餘可預出庫數量",
  prePickOutStockLimit: "可用庫存數量",
  prePickOutMaxLimit: "最大可填數量",
  deductOutCount: "扣減已出庫數量",
  inOrderDesc: "送貨單備註",
  plInventoryDesc: "請輸入送貨單備註",
  noSale: "沒有源銷售單，不可轉單", oldApprove: "原審批順序",
  newApprove: "新審批順序",
  approveSaveTip: "本次通過問詢單將同時保存新的審批順序",
  approveRemark: "審核備註",
  matchLocType: "庫存匹配庫位類型",
  rematch: "匹配庫存",
  rematchTip: "匹配庫存庫位類型已修改，請重新匹配庫存",
  priceFloor: "採購單價格取整",
  needReturn: "部分出庫單已確認出庫！",
  needReturnTip: "包含以下物料的領料單需要退庫",
  bomDatax: "系統BOM數據",
  templeData: "模版",
  xlsData: "銷售單BOM文件",
  dataTypeTip: "選擇匹配BOM數據源",
  dataTypeErr: "該銷售單BOM表數據解析異常",
  dataTypeErrTip: "請檢查該銷售單BOM表數據，或切換其他匹配BOM數據源",
  pickErr: "新的預出庫單：{{number}}庫存分配失敗，是否保留？",
  pickErrTip: "預出庫單：{{number}}，生成成功",
  pickErrContent: "請在倉儲管理分配庫存",
  pickErrDel: "生成預出庫單失敗",
  itemDesc: "物料備註",
  preOutErrTip: "需求清單{{number}}生成成功，預出庫單生成失敗，請重試！",
  rePreOutAdd: "重試預出庫",
  failPreTip: "需求單預出庫單生成失敗！",
  failPreTipDesc: "預出庫單生成失敗將導致需求單數量錯誤！如果不處理預出庫單失敗，建議刪掉本需求單重新跑！",
};

export default tr;
